import { createFileRoute } from '@tanstack/react-router';

import { useDataElTagGenerator } from '#utils/use-data-el-tag-generator.js';
import { UserThroughputTable } from './user-throughput-table.js';

export const Route = createFileRoute('/_authorization-gate/wizard/admin/user-throughput/')({
	head: () => ({ meta: [{ title: 'User Throughput • Wizard Admin • Cadstrom' }] }),
	component: WizardAdminUserThroughputPage,
});

function WizardAdminUserThroughputPage() {
	const el = useDataElTagGenerator(WizardAdminUserThroughputPage);
	return (
		<div {...el()} className='flex min-h-0 grow basis-0 flex-col gap-1.5 p-2'>
			<UserThroughputTable />
		</div>
	);
}
